import React from "react";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import { ColumnsEdit } from "types/models/column-table-edit";

export type DataTableMenu = {
  tenThuoc: any;
  hamLuong: any;
  donVi: any;
  soLuong: any;
  ghiChu: any;
};

let dataTableMenu: Array<DataTableMenu> = [];

const optionsLieuDung: any = [
  {
    label: "1 lần/ngày",
    value: 0,
  },
  {
    label: "2 lần/ngày",
    value: 1,
  },
  {
    label: "1 lần/ngày",
    value: 2,
  },
  {
    label: "Chọn liều dùng",
    value: -1,
  },
];
const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};
const columnsTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    render: (v, r, i) => i + 1,
    width: "2%",
  },
  {
    key: 1,
    dataIndex: "idThuoc",
    title: "Mã thuốc",
    align: "left",
    selected: true,
    width: "4%",
    rules: [{ required: true }],
  },
  {
    key: 2,
    dataIndex: "tenThuoc",
    title: "Tên thuốc",
    align: "left",
    editable: true,
    type: "AUTO_COMPLETE",
    width: 240,
  },
  {
    key: 5,
    dataIndex: "nongDo",
    title: "Nồng độ",
    align: "left",
    editable: true,
    type: "INPUT",
    disabled: true,
  },
  {
    key: 7,
    title: "Hoạt chất",
    dataIndex: "hoatChat",
    editable: true,
    type: "INPUT",
  },
  {
    key: 3,
    dataIndex: "donVi",
    title: "Đơn vị",
    align: "left",
    selected: true,
  },
  {
    key: 4,
    dataIndex: "soLuong",
    title: "Số lượng",
    align: "right",
    editable: true,
    type: "INPUT",
    width: "4%",
  },
  {
    key: 9,
    title: "Liều dùng",
    dataIndex: "lieuDung",
    editable: true,
    type: "INPUT",
    rules: [{ required: true, message: "Chưa nhập liều dùng" }],
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    width: "2%",
  },
];

export { columnsTableMenu, dataTableMenu, optionsLieuDung };
